var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgInfoIcon = function SvgInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#infoIcon_svg__clip0_13746_973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5A7.469 7.469 0 012.5 10c0-4.167 3.333-7.5 7.5-7.5s7.5 3.333 7.5 7.5-3.333 7.5-7.5 7.5z",
    fill: "#F05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6.083a.747.747 0 00-.75.75c0 .417.333.75.75.75s.75-.333.75-.75a.747.747 0 00-.75-.75z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10v4.167",
    stroke: "#fff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "infoIcon_svg__clip0_13746_973"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgInfoIcon;